export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('composables', {});
});
